export const zh = {
  home: '首页'
}